import { useEffect, useState } from 'react';
import Button from '@Web/Src/Components/Button';

function CookieBanner() {
    const [showCookieBanner, setShowCookieBanner] = useState(false);
    const [bannerVisible, setBannerVisible] = useState(false);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? match[2] : null;
    };

    const setCookie = (name, value, days) => {
        const expires = new Date();
        expires.setDate(expires.getDate() + days);
        document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
    };

    const handleAccept = () => {
        setCookie('accept_cookie', '1', 30);
        setBannerVisible(false);
        setTimeout(() => setShowCookieBanner(false), 500);
    };

    useEffect(() => {
        // use cookies
        const cookieAccepted = getCookie('accept_cookie');
        if (cookieAccepted !== '1') {
            setShowCookieBanner(true);
            setTimeout(() => setBannerVisible(true), 10);
        }
    }, []);

    return (
        <>
            {showCookieBanner && (
                <div
                    className={`bg-light fixed bottom-4 left-1/2 z-40 w-full max-w-[800px] -translate-x-1/2 transform rounded-lg p-6 font-sans shadow-[0px_0px_32px_0px_rgba(48,56,80,0.15)] transition-transform duration-500 ${
                        bannerVisible ? 'translate-y-0' : 'translate-y-full'
                    }`}
                >
                    <div className='small:block flex items-center space-x-4'>
                        <div className='flex-1'>
                            <div className='mb-2 flex items-center gap-2'>
                                <p className='text-2xl'>🍪</p>
                                <h3 className='text-lg font-semibold text-gray-900'>
                                    {__('We use cookies')}
                                </h3>
                            </div>

                            <p className='text-dark text-base'>
                                {__(
                                    'We use cookies to enhance your experience, and by continuing to visit our site you agree to our use of cookies.'
                                )}
                                &nbsp;
                                <a
                                    href='/general-terms'
                                    className='text-blue font-semibold underline'
                                >
                                    {__('Get more info here.')}
                                </a>
                            </p>
                        </div>
                        <Button
                            className='small:mt-4 min-w-28'
                            name={__('Got it')}
                            onClick={handleAccept}
                        />
                    </div>
                </div>
            )}
        </>
    );
}

export default CookieBanner;
